import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rm-footer',
  template: `
    
  `,
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/footer.component.ts